import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SignedURLDto, UploadDto } from '@monorepo/backend-lib/dtos';

@Injectable({
    providedIn: 'root'
})
export class ExcelService {
    private http = inject(HttpClient);
    private baseUrl = `${environment.apiConfig[0].uri}`;

    public getPreSignedUploadLink(workflowId: string): Observable<SignedURLDto> {
        return this.http.get<SignedURLDto>(`${this.baseUrl}/upload/workflow-data/${workflowId}/link`);
    }

    public uploadFileToS3(uploadUrl: string, file: File): Observable<void> {
        return this.http.put<void>(uploadUrl, file, {
            headers: {
                'Content-Type': file.type || 'application/octet-stream'
            }
        });
    }

    public getUserUploads(): Observable<UploadDto[]> {
        return this.http.get<UploadDto[]>(`${this.baseUrl}/upload`);
    }
}
